import { jsx, jsxs } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import React__default, { forwardRef } from "react";
import { P as PropTypes, t as tagPropType, m as mapToCssModules } from "../../../../utils-65a8d69b.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import { sass } from "../../../../sass/sass.js";
import "../../../../_commonjsHelpers-0c53d963.js";
var _excluded = ["className", "cssModule", "color", "innerRef", "pill", "tag"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes = {
  /** Pass children so this component can wrap the child elements */
  children: PropTypes.node,
  /** Add custom class */
  className: PropTypes.string,
  /** Change background color of Badge */
  color: PropTypes.string,
  /** Change existing className with a new className */
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  /** Add rounded corners to the Badge */
  pill: PropTypes.bool,
  /** Set a custom element for this component */
  tag: tagPropType
};
function Badge(props) {
  var className = props.className, cssModule = props.cssModule, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, innerRef = props.innerRef, _props$pill = props.pill, pill = _props$pill === void 0 ? !1 : _props$pill, _props$tag = props.tag, Tag = _props$tag === void 0 ? "span" : _props$tag, attributes = _objectWithoutProperties(props, _excluded), classes = mapToCssModules(classNames(className, "badge", "bg-" + color, pill ? "rounded-pill" : !1), cssModule);
  return attributes.href && Tag === "span" && (Tag = "a"), /* @__PURE__ */ React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
Badge.propTypes = propTypes;
const FlashBadge = forwardRef(function(props, ref) {
  const { id, text, color = "neutral", className, LeadingIcon } = props;
  return /* @__PURE__ */ jsx(
    Badge,
    {
      id,
      innerRef: ref,
      color: color === "neutral" ? "secondary" : `${color}_subtle`,
      className: classNames(COMMON_CLASSNAME, "flash-badge", { border: color === "outline" }, className),
      children: /* @__PURE__ */ jsxs("div", { className: "d-flex align-items-center gap-flash-025", children: [
        LeadingIcon && /* @__PURE__ */ jsx("div", { className: "d-inline-flex", children: /* @__PURE__ */ jsx(
          LeadingIcon,
          {
            color: sass.color.flash.semantic.icon[color],
            height: sass.typography.flash.semantic.font.label.l.size,
            width: sass.typography.flash.semantic.font.label.l.size
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "py-flash-050", children: text })
      ] })
    }
  );
});
export {
  FlashBadge as default
};
//# sourceMappingURL=FlashBadge.js.map
